import React, { FC } from 'react';
import { AdminTableFilterProps } from '../../../components/table/interfaces/AdminTableFilterProps';
import { TransactionsDateFilterState } from './TransactionsDateFilterState';
import { TransactionsDateFilter } from './TransactionsDateFilter';
import { TransactionPropertiesGroup } from './TransactionPropertiesGroup';

export const TransactionsDateReturnedFilter: FC<AdminTableFilterProps<TransactionsDateFilterState>> = (props) => {
  return <TransactionsDateFilter group={TransactionPropertiesGroup.Returned} {...props} />;
};
